import { useDispatch } from 'react-redux';
import { fetchNewsroomAssets } from '@client/content/redux/newsroom/redux';
import { bindActionCreators } from '@reduxjs/toolkit';

export const useFetchNewsroomAssetsAction = (): typeof fetchNewsroomAssets => {
  const dispatch = useDispatch();

  return bindActionCreators(fetchNewsroomAssets, dispatch);
};
